export const clocklog = state => state.clocklog.clocklog
